var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455 455",
    style: {
      enableBackground: "new 0 0 455 455"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M149.329,144.802c-11.069,0-18.7,1.105-22.547,2.209v71.674 c4.698,1.01,10.374,1.357,18.257,1.357c29.168,0,47.3-14.758,47.3-39.669C192.214,158.079,176.794,144.802,149.329,144.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M0,0v455h455V0H0z M224.219,236.693 c-18.604,17.595-46.417,25.479-78.834,25.479c-7.125,0-13.654-0.252-18.698-0.978v86.844H72.354V108.445 c16.872-2.837,40.647-5.046,74.136-5.046c33.899,0,58.021,6.401,74.167,19.456c15.64,12.204,25.983,32.417,25.983,56.194 C246.64,202.794,238.758,223.007,224.219,236.693z M306.27,351.601c-23.05,0-43.609-5.047-56.916-12.299l9.743-39.196 c10.091,6.055,30.904,13.307,47.173,13.307c16.492,0,23.398-5.77,23.398-14.789c0-8.988-5.424-13.276-25.856-20.182 c-36.484-12.202-50.518-32.038-50.139-52.976c0-32.763,28.096-57.644,71.676-57.644c20.592,0,38.944,4.667,49.76,10.091 l-9.714,37.839c-8.009-4.319-23.05-10.122-38.185-10.122c-13.307,0-20.813,5.424-20.813,14.412c0,8.261,6.781,12.581,28.318,20.213 c33.52,11.446,47.552,28.443,47.932,54.333C382.646,327.477,356.63,351.601,306.27,351.601z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.dcbd003623d561b2a5dd9e5e9d236b00.svg";
export { ForwardRef as ReactComponent };